export let PREQUAL_DATA =
{
    "request_id": "f8a45ad0-c3af-42c3-b04d-12b032e2f259",
    "lang_pref": "en",
    "is_coapplicant_applied": "N",
    "is_existing_bankcustomers": "N",
    "created_at": null,
    "updated_at": null,
    "status": "Pending Contact",
    "total_gross_income": 10000,
    "preQualify_mortgage_reference_number": "9100008034",
    "preQualify_mortgage_amount": 0,
    "preQualify_purchase_price": 0,
    "cmhc_default_insurance": 0,
    "total_mortgage_amount": 0,
    "down_payment": 0,
    "failure_reason": null,
    "failure_code": null,
    "monthly_PNI": null,
    "exception_reason_code": null,
    "madvsior": null,
    "email_ingest": null,
    "email_pdf": null,
    "users": [

        {
            "main_application": 0,
            "is_existing_bankcustomer": "Y",
            "customer_id": "3211696825",
            "firstname": "WENDIE",
            "middlename": "",
            "lastname": "TESCH",
            "date_of_birth": "1940-08-30",
            "addressline1": "1073 CREE AVE",
            "addressline2": "",
            "city": "WOODSTOCK",
            "province": "QC",
            "country_code": 146,
            "postal_code": "N4T 1A3",
            "mobilenumber": "+1 437-208-1881",
            "homenumber": null,
            "email": "anbazhagan.s4@tcs.com",
            "cb_consent": "Y",
            "ip_address": "157.51.86.171",
            "cb_datetime": "2025-12-31 06:56:08",
            "CBScore": 733,
            "eid_verified": true,
            "eid_details": null,
            "liability": [
                {
                    "outstandingBalance": 0,
                    "creditLimit": 4000,
                    "companyName": "SEARS",
                    "crTradeAccNum": "7854980000000679",
                    "liabilityCategory": "CBR",
                    "liabilityNumber": "CBRLIABFFFFFFFF001",
                    "liabilityType": "600",
                    "monthlyPaymentAmount": 0,
                    "cibcInstrumentIndicator": "N"
                },
                {
                    "outstandingBalance": 0,
                    "creditLimit": 1500,
                    "companyName": "CANADIAN TIRE FINANCIAL",
                    "crTradeAccNum": "1505640000000558",
                    "liabilityCategory": "CBR",
                    "liabilityNumber": "CBRLIABFFFFFFFF002",
                    "liabilityType": "600",
                    "monthlyPaymentAmount": 0,
                    "cibcInstrumentIndicator": "N"
                },
                {
                    "outstandingBalance": 0,
                    "creditLimit": 1500,
                    "companyName": "BANK OF MONTREAL M/C",
                    "crTradeAccNum": "1912300000004570",
                    "liabilityCategory": "CBR",
                    "liabilityNumber": "CBRLIABFFFFFFFF003",
                    "liabilityType": "600",
                    "monthlyPaymentAmount": 0,
                    "cibcInstrumentIndicator": "N"
                }
            ],
            "suffix": "",
            "address_api_certificate": "CRYPT:VTRLNU1uZWI4Z293N0N0cUpPVXdGcXpPOWZpQ1dLbEtRenk3Q0ZJZExub3pjWWJoRFZBaXpOMkxtb1JyNzJjZ25ocTNJV2xOd013TG9rZ09walp2aFZDUlBOK3hHNlZUc1RKYmZMS1I5Tnc5bElFR3JWc2h0YWxYM1dwWGtRVlZyVGh1d0VWdUs2cUUyTmNWbTc0OVpnUitab0xxdyt0UFdWMmxuYVZVWDE3elVpRFVxdXNNTzkzTEc1UVh4N21rb01EOVJNU1JxTlMwRERwM2IrSGl5U3NPejFoWWdOUHJpcWZiR1BpM0pmdmRJSWZZSDVybWJ3SW91YVNKMDhHOHd5NGxOVXh3RUdWcDhzQUVqTnlhcExESEhqWE9sZms2UU00YVZDV2V5aENUL2dHMlFHS1RZMGZaaVE0VDBtRTBWNDAzblZ1eWdmMlhsNStYajhRWXhJb29nUGRSb1lySzFyaWpJSDZIcUFVck1zVk93aVRVeU1pY3ZKdUxIcURxMWtaclBVMHFzb0E9",
            "referralLink": null
        },
        {
            "main_application": 1,
            "is_existing_bankcustomer": "Y",
            "customer_id": "3211696825",
            "firstname": "ASHA",
            "middlename": "",
            "lastname": "AHAL",
            "date_of_birth": "1940-08-30",
            "addressline1": "1073 CREE AVE",
            "addressline2": "",
            "city": "WOODSTOCK",
            "province": "ON",
            "country_code": 146,
            "postal_code": "N4T 1A3",
            "mobilenumber": "+1 437-208-1881",
            "homenumber": null,
            "email": "sweta.katre@tcs.com",
            "cb_consent": "Y",
            "ip_address": "157.51.86.171",
            "cb_datetime": "2025-12-31 06:56:08",
            "CBScore": 733,
            "eid_verified": true,
            "eid_details": null,
            "liability": [
                {
                    "outstandingBalance": 0,
                    "creditLimit": 4000,
                    "companyName": "SEARS",
                    "crTradeAccNum": "7854980000000679",
                    "liabilityCategory": "CBR",
                    "liabilityNumber": "CBRLIABFFFFFFFF001",
                    "liabilityType": "600",
                    "monthlyPaymentAmount": 0,
                    "cibcInstrumentIndicator": "N"
                },
                {
                    "outstandingBalance": 0,
                    "creditLimit": 1500,
                    "companyName": "CANADIAN TIRE FINANCIAL",
                    "crTradeAccNum": "1505640000000558",
                    "liabilityCategory": "CBR",
                    "liabilityNumber": "CBRLIABFFFFFFFF002",
                    "liabilityType": "600",
                    "monthlyPaymentAmount": 0,
                    "cibcInstrumentIndicator": "N"
                },
                {
                    "outstandingBalance": 0,
                    "creditLimit": 1500,
                    "companyName": "BANK OF MONTREAL M/C",
                    "crTradeAccNum": "1912300000004570",
                    "liabilityCategory": "CBR",
                    "liabilityNumber": "CBRLIABFFFFFFFF003",
                    "liabilityType": "600",
                    "monthlyPaymentAmount": 0,
                    "cibcInstrumentIndicator": "N"
                }
            ],
            "suffix": "",
            "address_api_certificate": "CRYPT:VTRLNU1uZWI4Z293N0N0cUpPVXdGcXpPOWZpQ1dLbEtRenk3Q0ZJZExub3pjWWJoRFZBaXpOMkxtb1JyNzJjZ25ocTNJV2xOd013TG9rZ09walp2aFZDUlBOK3hHNlZUc1RKYmZMS1I5Tnc5bElFR3JWc2h0YWxYM1dwWGtRVlZyVGh1d0VWdUs2cUUyTmNWbTc0OVpnUitab0xxdyt0UFdWMmxuYVZVWDE3elVpRFVxdXNNTzkzTEc1UVh4N21rb01EOVJNU1JxTlMwRERwM2IrSGl5U3NPejFoWWdOUHJpcWZiR1BpM0pmdmRJSWZZSDVybWJ3SW91YVNKMDhHOHd5NGxOVXh3RUdWcDhzQUVqTnlhcExESEhqWE9sZms2UU00YVZDV2V5aENUL2dHMlFHS1RZMGZaaVE0VDBtRTBWNDAzblZ1eWdmMlhsNStYajhRWXhJb29nUGRSb1lySzFyaWpJSDZIcUFVck1zVk93aVRVeU1pY3ZKdUxIcURxMWtaclBVMHFzb0E9",
            "referralLink": null
        }



    ],
    "error_description": null,
    "mmtg_ma_sync": "false",
    "time_to_purchase": null,
    "encodedRequestPreQual": null,
    "prequal_slider": null,
    "prequal_ltv": 0,
    "digitalLeadType": null,
    "prequalDMSelectStatus": false,
    "referralLink": "",
    "switchReqAmnt": 20000,
    "are_both_applicants_CIBC_customer": "N",
    "flow_type": "S",
    "mortgage_balance": 20000,
    "mortgage_provider": "Equitable Bank",
    "maturity": "In 4 months or more",
    "switch_interest_rate": null,
    "property_estimated_value": 40000,
    "property_address": {
        "addressline": "181 MONTCLAIR AVE",
        "apartment": "",
        "city": "TORONTO",
        "province": "ON",
        "postalCode": "M5P 1R1"
    },
    "amortization_payments": null,
    "equity_amount": "20000",
    "equity_ratio": "50",
    "insurance_eligible": null,
    "switch_rate_expires": null,
    "productId": null,
    "productCode": null,
    "rateTypeID": null,
    "term": null,
    "shortName": null,
    "arprateValue": null,
    "switched_liabilities": [
        {
            "outstandingBalance": 20000,
            "companyName": "Equitable Bank",
            "liabilityCategory": "CVD",
            "liabilityNumber": "SL00001",
            "liabilityType": "302",
            "statusCode": "O",
            "cibcInstrumentIndicator": "N"
        }
    ]
}